export function priceFormat({
	value,
	withCurrency = true,
}: {
	value: number;
	withCurrency?: boolean;
}) {
	const getCurrency = () => {
		if (withCurrency) {
			return 'RUB';
		}
		return undefined;
	};
	const getStyle = () => {
		if (withCurrency) {
			return 'currency';
		}
		return 'decimal';
	};

	const formatter = new Intl.NumberFormat('ru-RU', {
		style: getStyle(),
		currency: getCurrency(),
		minimumFractionDigits: 0,
	});
	return formatter.format(value);
}
